module.exports = __webpack_public_path__ + "img/donate.052cf703.png";